import React, { useEffect, useState } from "react";
import SigninButton from "./SigninButton/SigninButton";
import MenuCard from "./MenuCard/MenuCard";
import Tabs from "./Tabs/Tabs";
import AlphabetFilter from "./AlphabetFilter/AlphabetFilter";
import UserProfile from "./UserProfile/UserProfile";
import Logo from "../Logo/Logo";
import SearchBar from "../SearchBar/SearchBar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@asgardeo/auth-react";

const Header = ({
  showLogo = true,
  showSearch = true,
  showMenu = true,
  searchAnimation,
  showTab,
  showAlphabet,
  PlaceHolder,
  placeholderWords,
  enableSuggestions,
  enableFiltering,
  enableSearchTracking,
  SearchAsYouType,
  renderSearch,
  forceSignedOut = false,
}) => {
  const currentPage = useSelector((state) => state.home.currentPage);
  const navigate = useNavigate();
  const { state } = useAuthContext();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const isAuthenticated = state.isAuthenticated && !forceSignedOut;

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`${
        currentPage === "home"
          ? "bg-pl-bg"
          : "bg-pl-bg border-b border-pl-border fixed"
      } w-full z-[100]`}
    >
      <div className="xl:hidden">
        <div className="flex h-16 items-center px-3 md:px-10">
          {showLogo && (
            <div className="flex items-center">
              <button
                onClick={() => navigate("/")}
                className="flex items-center"
              >
                <Logo small />
              </button>
            </div>
          )}

          {showMenu && (
            <div className="ml-auto flex flex-none items-center gap-2 pl-2">
              <MenuCard
                showMobileSignin={false}
                dropdownClassName="fixed right-3 top-14 md:right-10"
              />
              {isAuthenticated ? <UserProfile /> : <SigninButton />}
            </div>
          )}
        </div>

        {showSearch && (
          <div className="px-3 pb-2 md:px-10">
            <div className="relative">
              {renderSearch ? (
                renderSearch({ size: "small" })
              ) : (
                <SearchBar
                  size="small"
                  PlaceHolder={PlaceHolder}
                  enableSuggestions={enableSuggestions}
                  enableFiltering={enableFiltering}
                  enableSearchTracking={enableSearchTracking}
                  SearchAsYouType={SearchAsYouType}
                  placeholderWords={placeholderWords}
                  searchAnimation={searchAnimation}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Desktop nav bar */}
      <div className="hidden h-16 xl:mt-3 xl:flex xl:items-center xl:px-0">
        {showLogo && (
          <div className="xl:flex xl:h-full xl:w-[208px] xl:items-center xl:justify-end xl:pr-4">
            <button
              onClick={() => navigate("/")}
              className="flex items-center"
            >
              <Logo small />
            </button>
          </div>
        )}

        <div className="xl:ml-[12px] xl:flex xl:h-full xl:flex-1 xl:items-center xl:px-0 xl:pr-20">
          {showSearch && (
            <div className="relative flex-grow">
              {renderSearch ? (
                renderSearch({ size: "small" })
              ) : (
                <SearchBar
                  size="small"
                  PlaceHolder={PlaceHolder}
                  enableSuggestions={enableSuggestions}
                  enableFiltering={enableFiltering}
                  enableSearchTracking={enableSearchTracking}
                  SearchAsYouType={SearchAsYouType}
                  placeholderWords={placeholderWords}
                  searchAnimation={searchAnimation}
                />
              )}
            </div>
          )}

          {showMenu && (
            <div className="ml-auto flex flex-none items-center gap-2 pl-2">
              <MenuCard showMobileSignin={!isAuthenticated && !isDesktop} />
              {isAuthenticated ? (
                <UserProfile />
              ) : (
                <div className="hidden md:block">
                  <SigninButton />
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Tabs — same xl offset as search bar and main content */}
      {showTab && (
        <div className="px-6 md:px-10 xl:pl-0 xl:pr-10 xl:ml-[220px]">
          <Tabs />
        </div>
      )}

      {showAlphabet && isDesktop && (
        <div className="px-6 md:px-10 xl:pl-0 xl:pr-10 xl:ml-[220px]">
          <AlphabetFilter />
        </div>
      )}
    </div>
  );
};

export default Header;
